(function($) {
  $(document).ready(function() {
      $('.cart-actions button[name="checkout"]').attr('disabled', !$(this).is(':checked'));

    
    
  })
    $(document).on('change', '.cart-agreement input[type="checkbox"]', function() {
        console.log($(this).is(':checked'), $('.cart-actions button[name="checkout"]'));
        $('.cart-actions button[name="checkout"]').attr('disabled', !$(this).is(':checked'));
    })


    $('#site-cart-handle').click((e) => {
        e.preventDefault();
        document.getElementById('site-cart').show();
    })
    $('.site-nav.style--classic .has-submenu').on('mouseenter', function() {
        $(this).find('.MegaMenu').attr('aria-hidden', 'false')
    })
    $('.site-nav.style--classic .has-submenu').on('mouseleave', function() {
        $(this).find('.MegaMenu').attr('aria-hidden', 'true')
    })

    $('.Slideshow__Carousel').each(function() {
        let slickData = $(this).data('slick-config');
        $(this).slick({
            arrows: slickData.prevNextButtons,
            adaptiveHeight: slickData.adaptiveHeight,
            pauseOnFocus: slickData.pauseAutoPlayOnHover,
            pauseOnHover: slickData.pauseAutoPlayOnHover,
            autoplay: slickData.autoPlay != false,
            autoplaySpeed: slickData.autoPlay,
            dots: slickData.pageDots,
            rtl: true,
        })
    })

    $('a[data-action="toggle-search"]').click(function(e) {
        e.preventDefault();

        console.log('search click');
        let curretnSearchState = $('#Search').attr('aria-hidden') === 'true';
        $('#Search').attr('aria-hidden', !curretnSearchState);
    })

    $('#site-menu-handle').click(function(e) {
        e.preventDefault();

        $('#site-nav--mobile').show().addClass('active');
    })
    $('.site-filter-handle').click(function() {
        $('#site-filters').show().addClass('active');
    })
    function mobileOnlySlider(selector, settings) {
        $(selector).slick(settings);
    }

    $('product-recommendations').on('product-recommendations-loaded', function() {
        console.log('product-recommendations-loaded');
        $('#section-related-products .product-grid-border-fix').slick({
            arrows: true,
            adaptiveHeight: false,
            dots: false,
            rtl: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg class="slider-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow"><svg class="slider-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" ></path></svg></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }

                }
            ]
        })
    })

    // let jsMobileCollectionSettings = {
    //     arrows: false,
    //     adaptiveHeight: true,
    //     dots: true,
    //     rtl: true,
    // }
    // $(window).resize(function(e){
    //     if(window.innerWidth < 768) {
    //         if(!$('.slider').hasClass('slick-initialized')){
    //             mobileOnlySlider();
    //         }
    //
    //     }else{
    //         if($('.slider').hasClass('slick-initialized')){
    //             $('.slider').slick('unslick');
    //         }
    //     }
    // });
    $(document).ready(function() {
        $('.js-mobile-collections').slick({
            arrows: false,
            adaptiveHeight: true,
            dots: true,
            rtl: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '10px',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]

        })
    })

    $('.js-buy-now').click(function(e) {
        e.preventDefault();
        $('.shopify-payment-button__more-options').trigger('click');
    })
})(window.jQuery)

